import { KeyValuePair } from "../../commonInterfaces";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { MultiSelect } from "../../core/components/multiSelect";
import { TextBox } from "../../core/components/textBox";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslationsInGrid, { ContainsLanguage } from "../editTranslationsInGrid";
import { SkillCategoryVm } from "./skillsInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export const openEditSkillCategory = (id: number, showOgrNrs: boolean) => {
    return new Promise<EditSkillCategory>((resolve, reject) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: EditSkillCategoryProps = {
            id: id,
            showOrgNrs: showOgrNrs,
            isNew: !Helper.hasValue(id),
            onOk: (result: EditSkillCategory) => {
                resolve(result);
            },
            onCancel: () => {
                root.unmount();
            }
        }
        $("body").append(targetElement);
        root.render(<EditSkillTreeGeneralSettings {...props} />);
    })
}

interface EditSkillCategoryProps {
    id: any;
    showOrgNrs: boolean;
    isNew: boolean;
    onOk: (data: EditSkillCategory) => void;
    onCancel: () => void;
}

export class EditSkillTreeGeneralSettings extends React.Component<EditSkillCategoryProps, {
    editSkillCategory?: EditSkillCategory;
    name: string;
    type: number;
}> {
    private kendoDialogRef: kendo.ui.Dialog;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCancel();
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk(this.state.editSkillCategory);
                },
                primary: true
            }
        ],
        afterClose: () => {
        }
    };

    constructor(props) {
        super(props)
        this.state = {
            editSkillCategory: {
                Translations: [],
                OgrNrs: [],
                SkillCategory: { FText: '', Type: -1 },
                IsNew: this.props.isNew
            },
            name: null,
            type: -1
        }
    }

    componentDidMount() {
        if (!this.props.isNew)
            this.loadData();
    }

    loadData = async () => {
        let result = await HTTPService.get<JsonResultClass<EditSkillCategory>>("EditSkill/GetSkillCategory?fId=" + encodeURIComponent(this.props.id));
        if (result.Code == 0) {
            this.setState({ editSkillCategory: result.Data, name: result.Data.SkillCategory.FText, type: result.Data.SkillCategory.Type });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private getMultiSelect = () => {
        let props = this.factory.getDefaultMultiSelectProps();
        props.value = this.state.editSkillCategory.OgrNrs;
        props.field.dataSourceUrl = "Nachschlag/GetMainGroups";
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let editSkillCategory = this.state.editSkillCategory;
            editSkillCategory.OgrNrs = value;
            this.setState({ editSkillCategory: editSkillCategory });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebCRM.Administration.Obergruppen")} noHover={true}>
                <div style={{ display: "flex" }}>
                    <MultiSelect {...props} />
                </div>
            </FieldInstance>
        );
    }

    private getHeader = (text: string) => {
        return <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{text}</label>;
    }

    renderEditTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Translation",
                title: Helper.getTranslation("Field.Ressource.name")
            },
            {
                visible: true,
                width: "100",
                field: "TranslationDescription",
                title: Helper.getTranslation("Field.fstasks.description"),
                multiLine: true
            }
        ];

        return <EditTranslationsInGrid
            id={"editSkillTreeCategoryTranslationsInGrid"}
            gridData={this.state.editSkillCategory.Translations}
            translationColumns={translationColumns}
            onDataLoaded={() => this.kendoDialogRef.center()} />
    }

    private getNameTextBoxProps = () => {
        let textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.state.name;
        textBoxProps.disabled = !this.props.isNew;
        textBoxProps.required = true;
        textBoxProps.onChange = (_, value: string) => {
            let skillCategory = this.state.editSkillCategory;
            skillCategory.SkillCategory.FText = value;
            this.setState({ name: value, editSkillCategory: skillCategory });
        };
        return textBoxProps;
    }

    private getTypDropDownProps = () => {
        let dropDownProps = this.factory.getDefaultDropDownProps();
        dropDownProps.value = this.state.type;
        dropDownProps.field.optionLabel = "";
        dropDownProps.required = true;
        dropDownProps.disabled = !this.props.isNew;
        dropDownProps.dataSource = [
            {
                value: -1,
                text: Helper.getTranslation("WebSMS.Skills.Folder")
            },
            {
                value: 13,
                text: Helper.getTranslation("Skills.Numeric")
            },
            {
                value: 19,
                text: Helper.getTranslation("Standard.Datum")
            }
        ];
        dropDownProps.field.dataTextField = "text";
        dropDownProps.field.dataValueField = "value";
        dropDownProps.onChange = (_, value) => {
            let skillCategory = this.state.editSkillCategory;
            skillCategory.SkillCategory.Type = value;
            this.setState({ type: value, editSkillCategory: skillCategory })
        }
        return dropDownProps;
    }

    private getDialog() {
        let showOgrNrs = this.props.showOrgNrs && this.state.type != -1;
        let textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.state.name;
        textBoxProps.onChange = (_, value: string) => {
            this.setState({ name: value })
        };
        return <Dialog {...this.dialogProps} open={true} dialogInternalRef={(ref) => this.kendoDialogRef = ref} width={"800px"} >
            <div style={{ display: "flex", flexDirection: "column" }}>
                <FieldInstance label={Helper.getTranslation("Standard.Designation")} required={true} >
                    <TextBox {...this.getNameTextBoxProps()} />
                </FieldInstance>
                <FieldInstance label={Helper.getTranslation("Standard.Typ")} required={true}>
                    <DropDownList {...this.getTypDropDownProps()} />
                </FieldInstance>
                <div style={{ marginTop: "10px" }}>
                    {this.getHeader(Helper.getTranslation("Skills.Uebersetzungen"))}
                    {this.renderEditTranslationsInGrid()}
                </div>
                <div style={{ marginTop: "10px" }}>
                    {showOgrNrs ? this.getHeader(Helper.getTranslation("WebSMS.UserSettings.MaingroupRights")) : null}
                    {showOgrNrs ? this.getMultiSelect() : null}
                </div>
            </div>
        </Dialog>
    }

    render() {
        let dialog = Helper.hasValue(this.state.editSkillCategory) || this.props.isNew ? this.getDialog() : null;
        return (<>
            {dialog}
        </>)
    }
}

interface EditSkillCategory {
    SkillCategory?: SkillCategoryVm;
    OgrNrs?: KeyValuePair<number, string>[];
    Translations?: EditSkillCategoryTranslation[];
    IsNew?: boolean;
}

interface EditSkillCategoryTranslation extends ContainsLanguage {
    TranslationName?: string;
    TranslationDescription?: string;
}